/**
 * Portal access label from user item.
 * Sponsor only → "360"; Sponsor + Vendor → "360 & Respond"; Vendor only → "Respond"
 */
export function getPortalAccessLabel(item) {
    const hasSponsor =
      item?.sponsor_subrole_dto?.length > 0 ||
      ["Sponsor User", "Sponsor Master User", "Sponsor Admin"].some(
        (r) => (item?.role || item?.main_role || "").indexOf(r) !== -1
      );
    const hasVendor =
      item?.is_dual_role === true ||
      !!item?.provider_user_id ||
      ["Provider User", "Provider Master User"].some(
        (r) => (item?.role || item?.main_role || "").indexOf(r) !== -1
      );
    if (hasSponsor && hasVendor) return "360 & Respond";
    if (hasSponsor) return "360";
    if (hasVendor) return "Respond";
    return "—";
}

export function getPortalAccessLabelFromVendor(item, providerOrgData = null) {
  if (providerOrgData?.isdual_role === false) return "Respond";

    const hasSponsor =
    item?.is_dual_role === true ||
      item?.isdual_role === true ||
    !!item?.sponsor_id ||
    item?.sponsor_subrole_dto?.length > 0 ||
    ["Sponsor User", "Sponsor Master User", "Sponsor Admin"].some(
      (r) => (item?.role || item?.main_role || "").indexOf(r) !== -1
    ) ||
    ["Sponsor User", "Sponsor Master User", "Sponsor Admin"].some(
      (r) => (item?.sub_roles || item?.sponsor_subrole_dto?.map((r) => r.sub_role))?.includes(r)
    );
    if (hasSponsor) return "Respond & 360";
    return "Respond";
}

export function getPortalAccessLabelFromSponsor(item, providerOrgData = null) {
  if (providerOrgData?.isdual_role === false) return "360";

    const hasVendor =
    item?.is_dual_role === true ||
    item?.isdual_role === true ||
    !!item?.provider_user_id ||
      ["Provider User", "Provider Master User", "Provider Admin"].some(
        (r) => (item?.role || item?.main_role || "").indexOf(r) !== -1
      ) ||
      ["Provider User", "Provider Master User", "Provider Admin"].some(
        (r) => (item?.sub_roles || item?.sponsor_subrole_dto?.map((r) => r.sub_role))?.includes(r)
      );
    if (hasVendor) return "360 & Respond";
    return "360";
}